var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx_wrap-container"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"skeleton-center"},[_c('el-skeleton',{attrs:{"rows":6,"animated":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }